import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { BacktrackAndGetPreviousQuestionRPC } from "./backtrackAndGetPreviousQuestionRPC";

export class BacktrackAndGetPreviousQuestionRPCClientImpl extends BacktrackAndGetPreviousQuestionRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: BacktrackAndGetPreviousQuestionRPC.Request): Promise<LeoRPCResult<BacktrackAndGetPreviousQuestionRPC.Response, BacktrackAndGetPreviousQuestionRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/BacktrackAndGetPreviousQuestion",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      BacktrackAndGetPreviousQuestionRPC.ResponseDTO,
      BacktrackAndGetPreviousQuestionRPC.Errors.ErrorsDTO,
      BacktrackAndGetPreviousQuestionRPC.Response,
      BacktrackAndGetPreviousQuestionRPC.Errors.Errors
    >(
      response,
      "survey-respondent/BacktrackAndGetPreviousQuestion",
      BacktrackAndGetPreviousQuestionRPC.Response.fromDTO,
      BacktrackAndGetPreviousQuestionRPC.Errors.fromDTO
    );
  }
}
